import { Component } from '@angular/core';

@Component({
    selector: 'tun-add-to-playlist-v5',
    templateUrl: './add-to-playlist-v5.component.html',
    styleUrls: ['./add-to-playlist-v5.component.scss'],
    standalone: false
})
export class AddToPlaylistV5Component {

}
